package uz.mint.frontend.pages.uz

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import uz.mint.frontend.components.layouts.PageLayoutData
import uz.mint.frontend.components.sections.LandingPage
import uz.mint.frontend.i18n.Locale
import uz.mint.frontend.i18n.stringsFor
import uz.mint.frontend.seo.IndexablePage

/** Uzbek landing page, exported to `/uz/`. */
private val LOCALE = Locale.UZ

@InitRoute
fun initUzbekHomePage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(stringsFor(LOCALE).metaTitle, LOCALE, page = IndexablePage.HOME))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun UzbekHomePage() {
    LandingPage(LOCALE)
}
